import { hideNotification } from '@ps-int/ps-components/src/notifications/slice';
import { fork, put, race, select, take, takeEvery, takeLatest, takeLeading } from 'typed-redux-saga';

import { navigateAction } from '../../../shared/helpers/navigation/slice';
import { resetAllFilters, setFilterArtifacts, setFilterFromTo } from '../features/filter/slice';
import { forceHistoryFullReload, scrollThresholdReached } from '../features/history-items/slice';
import { copyToCB, downloadReport, fetchMoreArtifactRecipients, setSelectedSessionId } from '../features/sidebar/slice';
import { selectForceReloadOnStartup, selectHasMoreConferences, selectIsBatchFetchingFailed } from '../selectors';
import { copyToClipboardSaga } from './copy-to-clipboard';
import { downloadReportSaga } from './download-report-saga';
import { fetchArtifactsSaga } from './fetch-artifacts';
import { fetchBatchSaga } from './fetch-batch';
import { fetchSummarizationRecipientSaga } from './fetch-recIpients';
import { fullListReloadSaga } from './full-list-reload';
import { metrikaSaga } from './metrika-saga';
import { resetFetchingErrorSaga } from './reset-fetching-error';
import { handleNavigateSaga } from './reset-filter-on-enter';

export function* conferencesHistorySaga() {
    yield* fork(metrikaSaga);
    yield* takeEvery(hideNotification, resetFetchingErrorSaga);
    yield* takeLatest(setSelectedSessionId, fetchArtifactsSaga);
    yield* takeLeading(copyToCB, copyToClipboardSaga);
    yield* takeEvery(fetchMoreArtifactRecipients, fetchSummarizationRecipientSaga);
    yield* takeLeading(downloadReport, downloadReportSaga);
    yield* takeEvery(navigateAction, handleNavigateSaga);
    let lastForkedSaga;
    const forceReloadOnStartup = yield* select(selectForceReloadOnStartup);
    if (forceReloadOnStartup) {
        lastForkedSaga = yield* fork(fullListReloadSaga);
    }
    while (true) {
        const [
            resetAllFiltersAction,
            setFilterFromAction,
            setFilterArtifactsAction,
            forceHistoryFullReloadAction,
            scrollThresholdReachedAction,
        ] = yield* race([
            take(resetAllFilters),
            take(setFilterFromTo),
            take(setFilterArtifacts),
            take(forceHistoryFullReload),
            take(scrollThresholdReached),
        ]);
        const isBatchFetchingFailed = yield* select(selectIsBatchFetchingFailed);
        const hasMoreConferences = yield* select(selectHasMoreConferences);
        if (resetAllFiltersAction || setFilterFromAction || setFilterArtifactsAction || forceHistoryFullReloadAction) {
            yield* put(setSelectedSessionId(null));
            lastForkedSaga?.cancel();
            lastForkedSaga = yield* fork(fullListReloadSaga);
        } else if (
            scrollThresholdReachedAction &&
            !lastForkedSaga?.isRunning() &&
            !isBatchFetchingFailed &&
            hasMoreConferences
        ) {
            lastForkedSaga = yield* fork(fetchBatchSaga);
        }
    }
}
